import styled from 'styled-components'
import SalesPipeLine from 'assets/sales-pipeline-small.svg'
import { Notification } from 'types/global'
import { ThemeColor } from 'utils/colors'

export const Highlight = styled.span`
  color: ${(p) => p.theme.colors.blue1};
  line-height: 22px;
  margin: 0 4px;
`

export const IconWrapper = styled.div<{ background: ThemeColor }>`
  align-items: center;
  background: ${({ theme, background }) => `${theme.colors[background]}1c`};
  border-radius: 4px;
  display: flex;
  height: 16px;
  justify-content: center;
  min-width: 16px;
  padding: 4px 5px 5px;
`

export const MarkReadRadio = styled.div<{ isRead: Notification['isRead'] }>`
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: ${({ theme, isRead }) => (!isRead ? theme.colors.blue1 : theme.colors.gray4)};
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 5px 0 ${({ theme, isRead }) => (!isRead ? theme.colors.blue1 : theme.colors.gray4)};
  }
`

export const NotificationItemWrapper = styled.div<{ isRead: Notification['isRead'] }>`
  background: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray4};
  display: flex;
  padding: 18px 24px 0 20px;

  &:hover {
    background: ${({ theme }) => theme.colors.blue5};
  }
`

export const SalesPipeLineIcon = styled(SalesPipeLine)`
  > g {
    stroke: #db7f8e;
  }
`
